/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Scope_Point_4Inputs */

const en_svc_research_scope_point_4 = /** @type {(inputs: Svc_Research_Scope_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fact-checking and source collection for content`)
};

const lv_svc_research_scope_point_4 = /** @type {(inputs: Svc_Research_Scope_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktu pārbaude un avotu vākšana saturam`)
};

/**
* | output |
* | --- |
* | "Fact-checking and source collection for content" |
*
* @param {Svc_Research_Scope_Point_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_scope_point_4 = /** @type {((inputs?: Svc_Research_Scope_Point_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Scope_Point_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_scope_point_4(inputs)
	return en_svc_research_scope_point_4(inputs)
});